export default () => {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self
  }
  if (typeof window !== 'undefined') {
    return window
  }
  if (typeof global !== 'undefined') {
    // eslint-disable-next-line no-undef
    return global
  }

  if (typeof globalThis !== 'undefined') {
    return globalThis
  }
  return null
}
